var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('Navbar'),_c('Homes'),_c('Swiper'),_c('PostsBooths'),_c('bottommenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }